export const ANOMALY_TYPE_TIME = 'Time';
export const ANOMALY_TYPE_ERROR = 'Error';
export const ANOMALY_TYPE_USAGE = 'Usage';
